import { __awaiter } from "tslib";
import getOptimizelyDefaultOptions from '../getOptimizelyDefaultOptions';
import initOptimizelyVanillaHelpersSDK from '../initOptimizelyVanillaHelpersSDK';
/**
 * calls instance.track('key') function with defualt attributes if optOut cookie is not set.
 *
 * @param  {string} eventKey - Custom metric event key.
 * @param  {object} customAttributes - customAttributes
 * @returns {Promise <void>}
 */
const trackOptimizelyVanillaEvent = (eventKey, customAttributes = {}) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const { attributes, userId } = getOptimizelyDefaultOptions();
    if (!window.optimizelyVanillaHelpersSDKInstance) {
        yield initOptimizelyVanillaHelpersSDK();
    }
    if (!attributes.optOut) {
        (_a = window === null || window === void 0 ? void 0 : window.optimizelyVanillaHelpersSDKInstance) === null || _a === void 0 ? void 0 : _a.track(eventKey, userId, Object.assign(Object.assign({}, attributes), customAttributes));
    }
});
export default trackOptimizelyVanillaEvent;
//# sourceMappingURL=trackOptimizelyVanillaEvent.js.map